import { Injectable, inject } from '@angular/core'
import { CanLoad, Route, Router, UrlSegment, UrlTree } from '@angular/router'
import { Observable } from 'rxjs'
import { UserService } from 'src/app/data/services/application/user/user.service'
import { SystemModules } from 'src/app/domain/utils/constants/system-modules'
import { TokenService } from '../token/token.service'

@Injectable({ providedIn: 'root' })
export class LoginGuard implements CanLoad {
  private userService: UserService = inject(UserService)
  private tokenService: TokenService = inject(TokenService)
  private router: Router = inject(Router)

  public canLoad(route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.userService.isLogged()) return true

    if (this.tokenService.isRefreshTokenExpired()) {
      this.userService.logout()
      return true
    }

    this.router.navigate([SystemModules.erp.uri])
    return false
  }
}
